import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.jsx'
import ErrorBoundary from './components/ErrorBoundary'
import { setDefaultConsent } from './utils/gtm'

// Set default consent state before anything else (GTM Consent Mode)
setDefaultConsent();

// Recover from stale asset hashes after redeploy (Vite emits this when
// a <link rel="modulepreload"> 404s). Reload once to pick up current chunks.
// Fixes JETOGO-FRONTEND-1N: "Unable to preload CSS for /assets/ReactToastify-*.css"
window.addEventListener('vite:preloadError', (e) => {
  const key = 'vite_preload_reloaded';
  if (!sessionStorage.getItem(key)) {
    sessionStorage.setItem(key, '1');
    e.preventDefault();
    window.location.reload();
  }
});

// Render React app first for faster FCP/LCP
createRoot(document.getElementById('root')).render(
  <StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </StrictMode>,
)

// Defer Sentry initialization to reduce TBT
// Uses requestIdleCallback with 3s timeout to ensure it runs
// This trades off capturing the very first milliseconds of errors
// for significantly faster initial page load
const initSentryDeferred = () => {
  import('./utils/sentry').then(({ initSentry }) => initSentry())
}

if ('requestIdleCallback' in window) {
  requestIdleCallback(initSentryDeferred, { timeout: 3000 })
} else {
  // Fallback for browsers without requestIdleCallback (Safari)
  setTimeout(initSentryDeferred, 100)
}

// AFFILIATE TRACKING
import('./utils/afglo').then(({ initAfglo }) => initAfglo());

// ACQUISITION TRACKING - capture UTM params, referrer, and affiliate codes on first landing
import { captureAcquisitionData } from './utils/acquisitionTracking';
captureAcquisitionData();
